var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8504 14.0001C12.6788 14.0001 13.3504 13.3285 13.3504 12.5C13.3504 11.6716 12.6788 11 11.8504 11C11.0219 11 10.3503 11.6716 10.3503 12.5C10.3503 13.3285 11.0219 14.0001 11.8504 14.0001Z",
    stroke: "#8790A1",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35014 14.0001C5.17859 14.0001 5.85018 13.3285 5.85018 12.5C5.85018 11.6716 5.17859 11 4.35014 11C3.52169 11 2.8501 11.6716 2.8501 12.5C2.8501 13.3285 3.52169 14.0001 4.35014 14.0001Z",
    stroke: "#8790A1",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35022 11.75H10.3503M9.22527 4.24976H9.93246C10.9153 4.24976 11.4068 4.24976 11.8234 4.48565C12.2401 4.72155 12.5179 5.15707 13.0735 6.02811C13.463 6.63887 13.872 7.08221 14.4471 7.47664C15.026 7.8737 15.3013 8.06781 15.4541 8.37937C15.6004 8.67773 15.6004 9.03113 15.6004 9.73788C15.6004 10.6696 15.6004 11.1355 15.3387 11.4316C15.3274 11.4443 15.316 11.4567 15.3041 11.4687C15.0286 11.75 14.595 11.75 13.7276 11.75H13.3504",
    stroke: "#8790A1",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85022 4.24976L9.59589 6.11398C9.96122 7.02738 10.1439 7.48407 10.5249 7.74193C10.9058 7.99986 11.3977 7.99986 12.3814 7.99986H14.8504",
    stroke: "#8790A1",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75221 11.75C1.73764 11.75 1.23035 11.75 0.915164 11.4205C0.599976 11.091 0.599976 10.5606 0.599976 9.49996V4.24982C0.599976 3.18913 0.599976 2.65878 0.915164 2.32927C1.23035 1.99976 1.73764 1.99976 2.75221 1.99976H6.69794C7.71257 1.99976 8.21981 1.99976 8.53504 2.32927C8.8502 2.65878 8.8502 3.18913 8.8502 4.24982V11.75H5.62185",
    stroke: "#8790A1",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIc);
export default __webpack_public_path__ + "static/media/truck_ic.072b907339b5130f880e46d26532f539.svg";
export { ForwardRef as ReactComponent };